import { tok_login } from "@/utils/HttpUtil";

export function login(params: any) {
  return tok_login(params, (response_data) => {
    return response_data;
  });
}
